import { render, staticRenderFns } from "./goodscateDetail.vue?vue&type=template&id=2309e295"
import script from "./goodscateDetail.vue?vue&type=script&lang=js"
export * from "./goodscateDetail.vue?vue&type=script&lang=js"
import style0 from "./goodscateDetail.vue?vue&type=style&index=0&id=2309e295&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports